import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AddCartPopupComponent } from '../shop/add-cart-popup/add-cart-popup.component';

@Injectable({
  providedIn: 'root'
})
export class ShopBlService {

  constructor(
    private modalController: ModalController,
  ) {

  }

  async selectProduct(productCard, measurement = false) {
    const popover = await this.modalController.create({
      component: AddCartPopupComponent,
      componentProps: {
        productId: productCard.id,
        measurement
      },
      cssClass: 'auto-height',
    });

    return await popover.present();
  }

}
